import * as React from 'react'
import styled, { css } from 'styled-components'
import media from '../../../../services/generateMediaQueries'

export const ButtonNavWrapper = styled.div`
position: absolute;
top: calc(200px - (52px / 2));
right: 6rem;

${props =>
  props.left &&
  css`
    right: unset;
    left: 6rem;
  `}

${media.lessThan('large')`
  right: 2rem;

  ${props =>
    props.left &&
    css`
      right: unset;
      left: 2rem;
    `}
`}

${media.lessThan('medium')`
  display: none;
`}
`

export const ButtonNav = styled.button`
  width: 3.25rem;
  height: 3.25rem;
  border-radius: 50%;
  outline: none;
  margin-right: 0.5rem;
  border: 1px solid var(--color-fg-lighter);
  font-size: 1.8rem;
  font-weight: var(--font-weight-bold);
  color: var(--color-fg-lighter);
  cursor: pointer;
  transition: all var(--animation-duration) var(--animation-easing);

  & > svg {
    margin-top: -5px;
    margin-left: ${props => (props.right ? 0 : '-5px')};
    margin-right: ${props => (props.right ? '-5px' : 0)};
  }

  :last-child {
    margin-right: 0;
  }

  :hover {
    background: var(--color-primary);
    border-color: transparent;
    color: white;
    transition: all var(--animation-duration) var(--animation-easing);
  }

  :focus {
    border-color: var(--color-primary);
    transition: all var(--animation-duration) var(--animation-easing);
  }
`

export const StyledBannerImage = styled.div`
  text-transform: uppercase;
  font-weight: var(--font-weight-black);
  font-size: 4rem;
  display: block;
  width: 100%;
  line-height: 1;
  letter-spacing: 0.2em;

  > * {
    display: block;
  }

  > :first-child {
    margin-left: -3rem;
  }

  > :first-child + * {
    margin-left: 3rem;
    font-size: 0.75em;
  }

  ${media.lessThan('medium')`
  font-size: 2.5rem;
  text-align: center;

  > :first-child {
    margin-left: 0;
  }

  > :first-child + * {
    margin-left: 0;
    font-size: 0.75em;
  }
`}
`

export const DefaultBannerTitle = styled.div.attrs({
  children: (
    <StyledBannerImage>
      <span>Amazing</span> <span>Discoveries</span>
    </StyledBannerImage>
  ),
})`
  text-transform: uppercase;
  font-weight: 900;
  font-size: 4rem;
  display: block;
  width: 100%;
  line-height: 1;
  letter-spacing: 0.2em;

  ${media.lessThan('medium')`
  padding: 0 3rem;
`}
`

export const BannerTitleContainer = styled.div`
  width: 100%;
  height: 20rem;
  position: relative;
  ${media.greaterThan('small')`
  padding: 3rem;
`}
`

export const BannerTitle = styled.div`
  background-color: currentColor;
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: contain;
  width: 100%;
  height: 100%;
`

export const sectionDescription = {
  order: {
    title: 'Order Now',
    description:
      'Relax, de-stress, and find something amazing to experience at Ayala Malls.',
  },
  shop: {
    title: 'Shop',
    description:
      'Discover what’s new and amazing in fashion, footwear, accessories, and more at Ayala Malls.',
  },
  dine: {
    title: 'Dine',
    description:
      'Go on a gastronomic adventure with an amazing lineup of cuisines, tastes, and flavors at Ayala Malls.',
  },
  unwind: {
    title: 'Unwind',
    description:
      'Relax, de-stress, and find something amazing to experience at Ayala Malls.',
  },
  featured: {
    title: 'Top Picks',
  },
}
